import { useCallback, useEffect, ReactNode } from 'react';
import { useRouter } from 'next/router';
import useScheduleDemoModal from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/useScheduleDemoModal';
import config from '@creditflowresearch/config';
import { LogoCreditFlowResearchStandart } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Standart';
import { isAnchorExist } from '@/creditflowresearch/ui/common/utils/url/isAnchorExist';
import URL from '@/creditflowresearch/Router/urlConstants';

interface IProps {
  children: ReactNode,
}

const BookDemoPageWrapper = ({ children }: IProps): React.ReactElement => {
  const { asPath, replace } = useRouter();
  const [currentPath] = asPath.split('#');
  const {
    isScheduleDemoModalVisible,
    toggleScheduleDemoModal,
    ScheduleDemoModal,
  } = useScheduleDemoModal();

  useEffect(() => {
    if (isAnchorExist(asPath)) {
      toggleScheduleDemoModal();
    }
  }, [asPath]);

  const closeModal = useCallback(() => {
    replace(currentPath, undefined, { shallow: true });
    toggleScheduleDemoModal();
  }, [asPath, toggleScheduleDemoModal]);

  const getInitialFormValues = useCallback(
    () => (currentPath === URL.EXTERNAL_API ? { scheduledDemoType: 'CreditFlowApi' } : null),
    [currentPath],
  );

  return (
    <>
      { isScheduleDemoModalVisible && (
        <ScheduleDemoModal
          tenant={ config.code }
          logoComponent={ LogoCreditFlowResearchStandart }
          closeModal={ closeModal }
          getInitialFormValues={ getInitialFormValues }
        />
      ) }
      { children }
    </>
  );
};

export default BookDemoPageWrapper;
